import Header from './components/Header';
import Hero from './components/Hero';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import UpdatesSection from './components/UpdatesSection';
import ContactSection from './components/ContactSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CommentsSection />
        <IndexSection />
        <CardsSection />
        <MediaSection />
        <RankingSection />
        <FaqSection />
        <AboutSection />
        <CarouselSection />
        <FeaturesSection />
        <AppSection />
        <UpdatesSection />
        <ContactSection />
        <TopicsSection />
      </main>
      <Footer />
    </>
  );
}